// Copyright (c) 2023 Proto Labs, Inc. All Rights Reserved.

/* eslint-disable require-jsdoc */
import { createStore } from 'vuex';
import tasApi from '@/api/tasApi';

export const actionTypes = Object.freeze({
	GET_FILE_TYPES: 'getFileTypes',
});

export const mutationTypes = Object.freeze({
	SET_TOAST: 'setToast',
});

class State {
	toast: IToast;

	constructor() {
		this.toast = {} as IToast;
	}
}

const store = createStore({
	state: new State(),
	actions: {
		async getFileTypes() {
			try {
				const response = await tasApi.getFileTypes();
				if (response?.status === 200) {
					return await response.json();
				}
			} catch (exception) {
				/* eslint-disable-next-line */
				console.log(exception);
			}
		},
	},
	mutations: {
		setToast(state: any, toast: IToast) {
			state.toast = toast;
			setTimeout(() => (toast.show = false), toast.timer);
		},
	},
});

export default store;
